export const checkRefereeWishMaxMatches = (referee, numMatches) => {
  let value = referee.maxMatches;
  if (value === undefined || value === "") {
    return true;
  } else if (numMatches < Number(value)) {
    return true;
  } else {
    return false;
  }
};
